import { useSpeciesName } from 'modules/pond/api/selector'
import React from 'react'
import { useTranslation } from 'react-i18next'

type PartialItem = {
  type: 'harvest' | 'transfer' | string
  age: number
}

export const useShrimpEventAnnotations = (partials?: PartialItem[]) => {
  const { t } = useTranslation(['common'])
  const speciesName = useSpeciesName()

  const shrimpEvents = React.useMemo(() => {
    if (!Array.isArray(partials)) return []
    return partials
      .filter(
        (item) =>
          item &&
          (item.type === 'harvest' || item.type === 'transfer') &&
          typeof item.age === 'number'
      )
      .map((item) => ({
        type: item.type,
        age: item.age,
      }))
  }, [partials])

  const eventAnnotations = React.useMemo(
    () =>
      shrimpEvents.map((event) => {
        const isHarvest = event.type === 'harvest'
        const color = isHarvest ? '#2196F3' : '#FFC107'

        return {
          x: event.age,
          borderColor: color,
          strokeDashArray: 6,
          label: {
            borderColor: color,
            style: {
              color: '#fff',
              background: color,
              fontSize: '12px',
              fontWeight: 600,
              writingMode: 'horizontal-tb',
              whiteSpace: 'nowrap',
            },
            orientation: 'horizontal',
            offsetY: -18,
            text: isHarvest ? t('harvest', { speciesName }) : t('transfer', { speciesName }),
          },
        }
      }),
    [shrimpEvents, t, speciesName]
  )

  return eventAnnotations
}
